function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1932(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32.9,
    height: 20.81,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 10.405
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.81,
    width: 32.9,
    height: 23.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 32.71
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.61,
    width: 32.9,
    height: 25.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 57.18
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.75,
    width: 32.9,
    height: 26.96,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.392
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 83.23
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.71,
    width: 32.9,
    height: 31.55,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1550000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 112.485
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.26,
    width: 32.9,
    height: 33.18,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 144.85
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.44,
    width: 32.9,
    height: 35.75,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 179.315
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 197.19,
    width: 32.9,
    height: 36.51,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 215.445
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 233.7,
    width: 32.9,
    height: 38.35,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6555555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 252.875
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 272.05,
    width: 32.9,
    height: 38.73,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 291.415
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310.77,
    width: 32.9,
    height: 40.4,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 330.96999999999997
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 351.17,
    width: 32.9,
    height: 42.56,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 372.45000000000005
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.73,
    width: 32.9,
    height: 47.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 417.445
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 441.16,
    width: 32.9,
    height: 47.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 464.96000000000004
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 488.76,
    width: 32.9,
    height: 48.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 512.96
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 537.16,
    width: 32.9,
    height: 53.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 563.935
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 590.71,
    width: 32.9,
    height: 54.57,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 617.995
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 645.28,
    width: 32.9,
    height: 54.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.45,
    y: 672.64
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 0,
    width: 39.3,
    height: 48.64,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.55,
    y: 24.32
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 0,
    width: 39.32,
    height: 48.64,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.553333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.86,
    y: 24.32
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.52,
    y: 0,
    width: 39.96,
    height: 48.64,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.5,
    y: 24.32
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.48,
    y: 0,
    width: 40.73,
    height: 48.64,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.788333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.845,
    y: 24.32
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.21,
    y: 0,
    width: 43.17,
    height: 48.64,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.79500000000002,
    y: 24.32
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.38,
    y: 0,
    width: 45.65,
    height: 48.64,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.205,
    y: 24.32
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.03,
    y: 0,
    width: 46.61,
    height: 48.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.661
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.335,
    y: 24.32
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.64,
    y: 0,
    width: 48.1,
    height: 48.64,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.372727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.69,
    y: 24.32
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.74,
    y: 0,
    width: 49.48,
    height: 48.64,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.106666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.48,
    y: 24.32
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.22,
    y: 0,
    width: 53.12,
    height: 48.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.213333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.78000000000003,
    y: 24.32
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.35,
    y: 0,
    width: 54.41,
    height: 48.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.555,
    y: 24.32
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.76,
    y: 0,
    width: 54.98,
    height: 48.64,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.106666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.25,
    y: 24.32
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.74,
    y: 0,
    width: 55.22,
    height: 48.64,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.35,
    y: 24.32
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.95,
    y: 0,
    width: 57.05,
    height: 48.64,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.404444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.475,
    y: 24.32
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 48.64,
    width: 57.93,
    height: 48.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.363333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 72.775
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 96.91,
    width: 57.93,
    height: 49.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.904
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 121.67
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 146.42,
    width: 57.93,
    height: 49.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.328333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 171.40499999999997
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 196.39,
    width: 57.93,
    height: 50.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.176666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 221.45
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 246.51,
    width: 57.93,
    height: 51.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 272.215
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 297.92,
    width: 57.93,
    height: 53.26,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.652
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 324.55
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 351.18,
    width: 57.93,
    height: 53.55,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 377.955
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 404.73,
    width: 57.93,
    height: 57.78,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 433.62
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 462.5,
    width: 57.93,
    height: 58.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.586
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 491.595
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 520.7,
    width: 57.93,
    height: 58.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 550.0250000000001
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 579.34,
    width: 57.93,
    height: 60.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 609.365
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 639.39,
    width: 57.93,
    height: 60.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.793
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.864999999999995,
    y: 669.6949999999999
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 48.64,
    width: 55.44,
    height: 65.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.55,
    y: 81.405
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.27,
    y: 48.64,
    width: 58.44,
    height: 65.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.687999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.49,
    y: 81.405
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.7,
    y: 48.64,
    width: 58.65,
    height: 65.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.33125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.02499999999998,
    y: 81.405
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.35,
    y: 48.64,
    width: 58.76,
    height: 65.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.73,
    y: 81.405
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.11,
    y: 48.64,
    width: 61.14,
    height: 65.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.68,
    y: 81.405
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.25,
    y: 48.64,
    width: 61.82,
    height: 65.53,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.303333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.16,
    y: 81.405
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.07,
    y: 48.64,
    width: 61.9,
    height: 65.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.02,
    y: 81.405
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.97,
    y: 48.64,
    width: 62.88,
    height: 65.53,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.4100000000001,
    y: 81.405
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.85,
    y: 48.64,
    width: 64.54,
    height: 65.53,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.171111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.12,
    y: 81.405
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.4,
    y: 48.64,
    width: 65.6,
    height: 65.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.1999999999999,
    y: 81.405
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 114.17,
    width: 70.44,
    height: 61.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 145.13
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 176.08,
    width: 70.44,
    height: 62.87,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 207.51500000000001
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 238.96,
    width: 70.44,
    height: 63.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.94875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 270.755
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 302.54,
    width: 70.44,
    height: 64.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.225714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 334.83000000000004
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 367.13,
    width: 70.44,
    height: 65.71,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.951666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 399.985
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 432.84,
    width: 70.44,
    height: 66.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.430000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 465.84499999999997
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 498.85,
    width: 70.44,
    height: 66.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 532.0550000000001
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 565.26,
    width: 70.44,
    height: 67.17,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.434000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 598.845
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.83,
    y: 632.42,
    width: 70.44,
    height: 67.58,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.654285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.05,
    y: 666.2099999999999
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 114.17,
    width: 72.51,
    height: 68.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.525,
    y: 148.4
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.78,
    y: 114.17,
    width: 73.67,
    height: 68.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.615,
    y: 148.4
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.45,
    y: 114.17,
    width: 74.14,
    height: 68.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.52,
    y: 148.4
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.6,
    y: 114.17,
    width: 76.47,
    height: 68.46,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.223636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.83500000000004,
    y: 148.4
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.06,
    y: 114.17,
    width: 80.44,
    height: 68.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.28,
    y: 148.4
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.51,
    y: 114.17,
    width: 80.48,
    height: 68.46,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.75,
    y: 148.4
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.99,
    y: 114.17,
    width: 81.01,
    height: 68.46,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.495,
    y: 148.4
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 182.62,
    width: 82.97,
    height: 66.87,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.374
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 216.055
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 249.49,
    width: 82.97,
    height: 71.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 285.43
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 321.37,
    width: 82.97,
    height: 72.1,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.299999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 357.42
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 393.48,
    width: 82.97,
    height: 74.8,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 430.88
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 468.28,
    width: 82.97,
    height: 75.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.85142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 506.26
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 544.24,
    width: 82.97,
    height: 76.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.62375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 582.735
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.27,
    y: 621.23,
    width: 82.97,
    height: 78.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.752222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.755,
    y: 660.615
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.24,
    y: 182.62,
    width: 87.65,
    height: 77.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.868333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.065,
    y: 221.225
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.89,
    y: 182.62,
    width: 88.36,
    height: 77.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.07,
    y: 221.225
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.25,
    y: 182.62,
    width: 88.71,
    height: 77.21,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.578888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.605,
    y: 221.225
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.97,
    y: 182.62,
    width: 95.27,
    height: 77.21,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.868333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.605,
    y: 221.225
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.23,
    y: 182.62,
    width: 95.77,
    height: 77.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.441999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.115,
    y: 221.225
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.24,
    y: 259.83,
    width: 92.28,
    height: 80.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.038
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.38,
    y: 300.02
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.24,
    y: 340.21,
    width: 92.28,
    height: 89.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.1725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.38,
    y: 384.9
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.24,
    y: 429.59,
    width: 92.28,
    height: 89.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.79857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.38,
    y: 474.385
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.24,
    y: 519.18,
    width: 92.28,
    height: 90.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.38,
    y: 564.2199999999999
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.24,
    y: 609.26,
    width: 92.28,
    height: 90.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.123333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.38,
    y: 654.63
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.53,
    y: 259.83,
    width: 88.51,
    height: 99.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.851
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.78499999999997,
    y: 309.78
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.03,
    y: 259.83,
    width: 88.81,
    height: 99.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.10125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.43499999999995,
    y: 309.78
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.84,
    y: 259.83,
    width: 93.01,
    height: 99.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.62625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.345,
    y: 309.78
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 606.85,
    y: 259.83,
    width: 93.15,
    height: 99.9,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.4250000000001,
    y: 309.78
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.53,
    y: 359.73,
    width: 89.59,
    height: 110.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.79857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.325,
    y: 414.845
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.53,
    y: 469.96,
    width: 89.59,
    height: 110.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.918
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.325,
    y: 525.405
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.53,
    y: 580.85,
    width: 89.59,
    height: 119.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.19875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.325,
    y: 640.4250000000001
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.12,
    y: 359.73,
    width: 133.35,
    height: 89.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.795,
    y: 404.35
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.46,
    y: 359.73,
    width: 140.54,
    height: 89.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.873333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.73,
    y: 404.35
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.12,
    y: 448.97,
    width: 119.12,
    height: 116.21,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.60142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.68,
    y: 507.07500000000005
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.12,
    y: 565.17,
    width: 119.12,
    height: 134.83,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.82909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.68,
    y: 632.5849999999999
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.24,
    y: 448.97,
    width: 154.76,
    height: 121.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.62,
    y: 509.83000000000004
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.24,
    y: 570.69,
    width: 154.76,
    height: 129.31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.62,
    y: 635.345
  }, "\n        Guilford\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1932);
export default __webpack_public_path__ + "static/media/1932.c79ae0dbc5dcfa7d793a309ef91d336f.svg";
export { ForwardRef as ReactComponent };